if (!customElements.get('sleeq-primer')) {
 customElements.define('sleeq-primer', class extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   this.querySelectorAll('[data-sp-compare]').forEach(stage=>{
    const input=stage.querySelector('input[type="range"]'),before=stage.querySelector('.sp-before-image'),line=stage.querySelector('.sp-compare-line');if(!input||!before||!line)return;
    let activePointer=null;
    const update=value=>{const percent=Math.max(0,Math.min(100,Number(value)||0));input.value=String(percent);input.setAttribute('aria-valuetext',`${Math.round(percent)}% of before image revealed`);before.style.clipPath=`inset(0 ${100-percent}% 0 0)`;line.style.left=`${percent}%`;};
    const fromPointer=event=>{const bounds=stage.getBoundingClientRect();if(bounds.width)update((event.clientX-bounds.left)/bounds.width*100);};
    update(input.value);input.addEventListener('input',()=>update(input.value),{signal});
    stage.addEventListener('pointerdown',event=>{if(!event.isPrimary||(event.pointerType==='mouse'&&event.button!==0))return;activePointer=event.pointerId;stage.setPointerCapture(event.pointerId);input.focus({preventScroll:true});fromPointer(event);},{signal});
    stage.addEventListener('pointermove',event=>{if(event.pointerId===activePointer)fromPointer(event);},{signal});
    const finish=event=>{if(event.pointerId!==activePointer)return;activePointer=null;if(stage.hasPointerCapture(event.pointerId))stage.releasePointerCapture(event.pointerId);};
    stage.addEventListener('pointerup',finish,{signal});stage.addEventListener('pointercancel',finish,{signal});stage.addEventListener('lostpointercapture',()=>{activePointer=null;},{signal});
   });
   const track=this.querySelector('[data-sp-review-track]');if(track){
    const prev=this.querySelector('[data-sp-prev]'),next=this.querySelector('[data-sp-next]');
    const state=()=>{if(prev)prev.disabled=track.scrollLeft<=2;if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
    const move=direction=>{const card=track.querySelector('.sp-review-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    prev?.addEventListener('click',()=>move(-1),{signal});next?.addEventListener('click',()=>move(1),{signal});track.addEventListener('scroll',state,{signal,passive:true});this.resizeObserver=new ResizeObserver(state);this.resizeObserver.observe(track);state();
    this.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.sp-review-card');if(card&&track.contains(card))track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'auto'});},{signal});
   }
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect();}
 });
}

if (!window.spQuickAddInitialized) {
  window.spQuickAddInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sp-quick-add]');

    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const card = button.closest('.sp-product-card');
    const error = card?.querySelector('.sp-quick-add-error');
    const root = window.Shopify?.routes?.root || '/';

    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const payload = {
        items: [{ id: variantId, quantity: 1 }]
      };

      if (typeof cart?.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender()
          .map(section => section.section || section.id);

        payload.sections_url = window.location.pathname;
      }

      cart?.setActiveElement?.(button);

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || result.message || 'Unable to add this item.'
        );
      }

      if (
        result.sections &&
        typeof cart?.renderContents === 'function'
      ) {
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } else {
        window.location.assign(`${root}cart`);
      }
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
}

function colorPrimerCtaHeading() {
  document.querySelectorAll('.sp-cta h2').forEach((heading) => {
    const br = heading.querySelector('br');

    if (!br || heading.querySelector('.sp-cta-heading-accent')) return;

    const span = document.createElement('span');
    span.className = 'sp-cta-heading-accent';

    while (br.nextSibling) {
      span.appendChild(br.nextSibling);
    }

    br.after(span);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', colorPrimerCtaHeading);
} else {
  colorPrimerCtaHeading();
}

document.addEventListener('shopify:section:load', colorPrimerCtaHeading);